import React, {createContext, useState, useContext} from "react";
import ReactDOM from "react-dom";

const ModalContext = createContext();

export const ModalProvider = ({children}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const modalOpen = (content) => {
        setModalContent(content); // 초기화
        setIsOpen(true);
    };


    const modalClose = () => {
        setModalContent(null);
        setIsOpen(false);
    };

    return (
        <ModalContext.Provider value={{modalOpen, modalClose}}>
            {children}
            {ReactDOM.createPortal(
                isOpen && (
                    <>
                        <div className="wbz-popup-bg" id="wbz-popup-bg" style={{zIndex: 9000}}></div>
                        {modalContent}
                    </>
                ),
                document.body
            )}
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);
